<template>
    <div>
        <Breadcrumb class="breadcrumb">
            <BreadcrumbItem class="click" to="/teachAdmin/courseManag/index">
                课程管理
            </BreadcrumbItem>
            <BreadcrumbItem>新增数据集</BreadcrumbItem>
        </Breadcrumb>
        <div class="create-box">
            <div class="create-box-title">
                <h3>基本信息</h3>
            </div>
            <Form ref="createForm" :model="createForm" label-position="left" :label-width="110" :rules="ruleValidate">
                <FormItem label="数据集类型" v-if="mcpInfo.mcp_type_name != '' ">
                    {{mcpInfo.mcp_type_name}}
                </FormItem>
                <FormItem label="数据集类型" v-else>
                    未选择环境不可创建
                </FormItem>
                <FormItem label="数据集名称" class="form-item" prop='name'>
                    <Input v-model="createForm.name" style="width: 200px" placeholder="请输入数据集名称"></Input>
                </FormItem>
                <br />
                <FormItem label="描述信息">
                    <Input v-model="createForm.remark" type="textarea" style="width:400px;"
                           placeholder="请输入描述信息"></Input>
                </FormItem>
                <br />
                <FormItem label="数据集文件">
<!--                    <Upload-->
<!--                            multiple-->
<!--                            :data="uploadForm"-->
<!--                            :action="dataSetUploadUrl"-->
<!--                            :show-upload-list="showUploadList"-->
<!--                            :on-success="dataSetSuccess"-->
<!--                            :on-error="dataSetErr"-->
<!--                            style="width:40%"-->
<!--                            :format="['txt','csv']"-->
<!--                            accept=".txt,.csv"-->
<!--                            :max-size="maxSize"-->
<!--                            :on-exceeded-size="uploadMaxSizeFunc"-->
<!--                    >-->
<!--                        <Button icon="ios-cloud-upload-outline" @click="uploadDataSet">选择文件</Button>-->
<!--                        <span class="text-label">请选择大小不超过300M的文件</span>-->
<!--                    </Upload>-->

                    <uploadComm
                            :data="uploadForm"
                            :action="dataSetUploadUrl"
                            :showUploadList="showUploadList"
                            :onSuccess="dataSetSuccess"
                            :sstyle="style"
                            :format="['txt','csv']"
                            accept=".txt,.csv"
                            :uploadFunc="uploadDataSet"
                    >
                    </uploadComm>

                </FormItem>

                <FormItem label="" class="form-item" v-if="dataSetTableShow">
                    <Table border
                           :columns="columns"
                           :data="dataSetData"
                           size="small"
                           width="600"
                    ></Table>
                </FormItem>
            </Form>
            <Button type="primary" @click="create" v-if="mcpInfo.mcp_type.name != '' ">提交</Button>
        </div>
    </div>
</template>
<script>
    import cookie from "vue-cookies";
    import {mapActions} from 'vuex'
    import uploadComm from '@/components/upload/upload'
    export default {
        name: 'createDataSet',
        components:{
            uploadComm
        },
        data() {
            return {
                style:"width:40%",
                ruleValidate:{
                    name: [
                        { required: true, message: '数据集名称必填', trigger: 'blur' }
                    ]
                },
                uploadForm:{
                    uuid_rel:'',
                },
                uuid:'',
                dataSetTableShow:false,
                showUploadList:true,
                dataSetUploadUrl:'',
                mcpInfo:{'mcp_type':{name:''}},
                files:[],
                createForm: {
                    name:"",
                    uuid_rel:"",
                    files:[],
                    mcp_type:0,
                    mcp_endpoint_id:0,
                    remark:"",
                },
                dataSetData:[],
                columns:[
                    {
                        title: '文件名',
                        key: 'name',
                        align: 'center',
                        tooltip:true
                    },
                    {
                        title: '状态',
                        key: 'status',
                        align: 'center'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color: '#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            // this.dataSetData.splice(params.index,1)
                                            this.delDataSetData(params.index,params.row.id)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    }
                ]
            }
        },
        methods:{
            uploadDataSet(){
                let access_token = cookie.get('session');
                this.dataSetUploadUrl = this.mcpInfo.mcp_endpoint.domain_name+`/agentsvc/tm/course/ds/file?access_token=${access_token}`;
            },
            dataSetSuccess(response){
                // 如果成功
                if(response.status.code === 2000000){
                    this.dataSetTableShow = true;
                    this.showUploadList = false;
                    var file_info = {
                        id: response.body.id,
                        name:response.body.filename,
                        status:'上传成功'
                    }
                    this.dataSetData.push(file_info)
                    this.files.push(file_info.id)
                }else{
                    this.$Message.error(response.status.message)
                }
            },
            // 删除上传后文件
            delDataSetData(index,id){
                let _this = this;
                this.delDataSetFileData(
                    {
                    url:this.mcpInfo.mcp_endpoint.domain_name,data:id,
                    callback:()=>{
                        this.dataSetData.splice(index,1);
                        this.files.forEach((value,index)=>{
                            if(id == value){
                                this.files.splice(index,1);
                            }
                        })
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                });
            },
            create(){
                let _this = this;
                // 验证
                this.$refs['createForm'].validate((valid) => {
                    if(valid){
                        if(_this.files.length >0){
                            _this.files.forEach(item=>{
                                _this.createForm.files.push({id:item});
                            });
                            this.createDataSet({
                                url:this.mcpInfo.mcp_endpoint.domain_name,
                                data:_this.createForm,
                                callback:res =>{
                                    _this.$Message.success('创建成功！');
                                    this.$router.push({
                                        name: 'courseManagList',
                                        params: {current: 'dataSet'}
                                    })
                                },
                                error:msg =>{
                                    _this.$Message.error({
                                        content: msg,
                                        duration:4
                                    });
                                }
                            })
                        }else{
                            _this.$Message.error('数据集文件必须上传');
                        }
                    }else{
                        _this.$Message.error('Fail!');
                    }
                })
            },
            ...mapActions({
                delDataSetFileData:'courseAdminDataSet/delDataSetFileData',
                createDataSet:'courseAdminDataSet/createDataSet',
                getUuid:'common/get_uuid',
                get_availableSvc:'common/get_availableSvc'
            })
        },
        created() {
            let _this = this;
            let mcpId = this.$route.params.mcpid;
            //获取uuid
            this.getUuid({
                callback:function (res) {
                    _this.createForm.uuid_rel = res.uuid;
                    _this.uploadForm.uuid_rel = res.uuid;
                }
            });
            if(mcpId != undefined && mcpId > 0){
                // 获取可用节点
                this.get_availableSvc({
                    callback:res=>{
                        res.forEach(item=>{
                            if(item.mcp_type === parseInt(mcpId)){
                                _this.mcpInfo = item;
                                _this.createForm.mcp_type = item.mcp_type;
                                _this.createForm.mcp_endpoint_id = item.mcp_endpoint.id;
                            }
                        })
                    }
                })
            }
        },
    }
</script>
<style scoped lang="less">
    @import "../../../style/index";
    @import "../../../../../assets/style/exercises";
</style>
